 https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
 ( function () {
     'use strict';
     jQuery.extend( true, e4.settings, {
         search: {
             delay: {
                 min: 100,
                 max: 1000
             },
             result: {
                 pages: {
                     show: true,  
                     url: '/data/pages?q='
                 },
                 products: {
                     show: false,
                     url: '/system/data/products?q=',
                     showAllLink: '/shop/search?q=',
                     max: {
                         xs: 2,
                         sm: 2,
                         md: 4,
                         lg: 4,
                         xl: 4
                     }
                 }
             }
         },
         intersectionObserver: {
             options: {
                 root: null,
                 rootMargin: '0px',
                 threshold: 0
             }
         }
     } );
 }() );

